import React, { ReactElement } from 'react'

import {
  Box,
  Flex,
  Label,
  RadioButton,
  Text,
} from '@mindfulchefuk/design-system'

type TPortionSize = {
  availablePortions: number[]
  portionSize: number
  onClick: (size: number) => void
}

export const PortionSize = ({
  availablePortions,
  portionSize,
  onClick,
}: TPortionSize): ReactElement => {
  if (!availablePortions.length)
    return <Text variant="body-lg">No portions available for this recipe</Text>

  return (
    <Box>
      <Label>Serving size</Label>
      <Flex wrap="wrap">
        <Box pr={16} pb={10}>
          <RadioButton
            data-testid="portion-size-radio-1"
            value={1}
            onChange={(event) => onClick(parseInt(event.target.value, 10))}
            checked={portionSize === 1}
            disabled={!availablePortions.includes(1)}
          >
            1 person
          </RadioButton>
        </Box>
        <Box pr={16}>
          <RadioButton
            data-testid="portion-size-radio-2"
            value={2}
            onChange={(event) => onClick(parseInt(event.target.value, 10))}
            checked={portionSize === 2}
            disabled={!availablePortions.includes(2)}
          >
            2 people
          </RadioButton>
        </Box>
        <RadioButton
          data-testid="portion-size-radio-4"
          value={4}
          onChange={(event) => onClick(parseInt(event.target.value, 10))}
          checked={portionSize === 4}
          disabled={!availablePortions.includes(4)}
        >
          4 people
        </RadioButton>
      </Flex>
    </Box>
  )
}
